export const ROLE_TECHNICIAN = "Tech";

export const TYPE_RWA = "RWA"

export const isTechnician = (user) => {
    if(!user)
        return false;

    if(!user.role)
        return false;

    return (user.role === ROLE_TECHNICIAN);
}

export const isRWA = (user) => {
    if(!user)
        return false;

    if(!user.type)
        return false;

    return (user.type === TYPE_RWA);
}


